document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const openButton = event.target.closest(
    '[data-copco-sizechart-open]'
  );

  if (openButton) {
    event.preventDefault();

    const drawerId = openButton.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);

    if (!drawer) return;

    /* Drawer aus dem Stacking-Context der Produktsektion lösen */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    return;
  }

  const closeButton = event.target.closest(
    '[data-copco-sizechart-close]'
  );

  if (closeButton) {
    event.preventDefault();

    const drawer = closeButton.closest('.copco-drawer');

    if (!drawer) return;

    closeDrawer(drawer);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const drawer = document.querySelector(
    '.copco-drawer:not([hidden])'
  );

  if (!drawer) return;

  closeDrawer(drawer);
});

function closeDrawer(drawer) {
  drawer.hidden = true;

  const opener = document.querySelector(
    `[data-copco-sizechart-open][aria-controls="${drawer.id}"]`
  );

  if (opener) {
    opener.setAttribute('aria-expanded', 'false');
  }

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
}